/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Code_Claimed_TitleInputs */

const en_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Code Entered`)
};

const ar_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إدخال رمز الدعوة`)
};

const de_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungscode eingegeben`)
};

const es_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de invitación introducido`)
};

const fr_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d’invitation saisi`)
};

const it_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice invito inserito`)
};

const ja_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コード入力済み`)
};

const ko_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드 입력됨`)
};

const pt_br_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de convite inserido`)
};

const ru_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код приглашения введен`)
};

const th_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอกรหัสเชิญแล้ว`)
};

const tr_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodu girildi`)
};

const zh_cn_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已输入邀请码`)
};

const zh_tw_invite_code_claimed_title = /** @type {(inputs: Invite_Code_Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已輸入邀請碼`)
};

/**
* | output |
* | --- |
* | "Invite Code Entered" |
*
* @param {Invite_Code_Claimed_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_code_claimed_title = /** @type {((inputs?: Invite_Code_Claimed_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Code_Claimed_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_code_claimed_title(inputs)
	if (locale === "ar") return ar_invite_code_claimed_title(inputs)
	if (locale === "de") return de_invite_code_claimed_title(inputs)
	if (locale === "es") return es_invite_code_claimed_title(inputs)
	if (locale === "fr") return fr_invite_code_claimed_title(inputs)
	if (locale === "it") return it_invite_code_claimed_title(inputs)
	if (locale === "ja") return ja_invite_code_claimed_title(inputs)
	if (locale === "ko") return ko_invite_code_claimed_title(inputs)
	if (locale === "pt_br") return pt_br_invite_code_claimed_title(inputs)
	if (locale === "ru") return ru_invite_code_claimed_title(inputs)
	if (locale === "th") return th_invite_code_claimed_title(inputs)
	if (locale === "tr") return tr_invite_code_claimed_title(inputs)
	if (locale === "zh_cn") return zh_cn_invite_code_claimed_title(inputs)
	return zh_tw_invite_code_claimed_title(inputs)
});